import { HeadContent, Outlet, createRootRoute } from '@tanstack/react-router';
// TanStackRouterDevtools is already conditionally imported below
// import { TanStackRouterDevtools } from '@tanstack/router-devtools';
// ReactQueryDevtools is already conditionally imported below
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { Suspense } from 'react';

// Import global styles. This should have Tailwind base, components, utilities, and our theme variables.
// USER ACTION: Please verify 'apps/trapeze-dashboard/src/index.css' is correctly set up as per previous logs.
import '@/index.css';
import { Toaster } from '@/components/ui/sonner';

// Placeholder for a ThemeProvider, e.g., from a library like next-themes or a custom one
// import { ThemeProvider } from '@/components/theme-provider';

const LazyTanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
        }))
      );

const LazyReactQueryDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null
    : React.lazy(() =>
        import('@tanstack/react-query-devtools').then((res) => ({
          default: res.ReactQueryDevtools,
        }))
      );

// Let createRootRoute infer the options type
const rootRouteOptions = {
  component: RootLayout,
  head: () => ({
    title: 'Trapeze Dashboard', // Direct title for <title> tag
    meta: [
      { charSet: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'description', content: 'Trapeze Dashboard for managing operations.' },
    ],
    // links: () => [], // Example if you had links
  }),
};

export const Route = createRootRoute(rootRouteOptions);

function RootLayout() {
  return (
    // If using a ThemeProvider component (e.g., for context-based theme state):
    // <ThemeProvider defaultTheme="system" storageKey="trapeze-ui-theme">
    <>
      <HeadContent />
      <Outlet />
      <Toaster />
      <Suspense fallback={null}>
        <LazyTanStackRouterDevtools position="bottom-right" />
        <LazyReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
      </Suspense>
    </>
    // </ThemeProvider>
  );
}
